import React from "react"
import { AnchorNumber } from "components/anchor-number/AnchorNumber"
import { useMainOfficeNumber } from "hooks/useMainOfficeNumber"

import "./optional-cta-phone-link.module.scss"

interface OptionalCTAPhoneLinkProps {
  hideLabel?: boolean
}

export const OptionalCTAPhoneLink = ({
  hideLabel,
}: OptionalCTAPhoneLinkProps) => {
  const { mainOfficeNumber } = useMainOfficeNumber({})

  return (
    <p className="fr-phone">
      {!hideLabel && <>Or Call </>}
      <AnchorNumber
        contactNumber={mainOfficeNumber}
        baseClassName="fr-phone-link"
        showIcon={false}
      />
    </p>
  )
}
